import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useCollection } from '../../hooks/useCollection'
import { useFirestore } from '../../hooks/useFirestore'




// styles
import styles from './Home.module.css'
import StudentForm from './StudentForm'

export default function StudentsInfo({ students }) {
  const { deleteDocument } = useFirestore('student')
  const [isLoading, setIsLoading] = useState(true);
  const handleiframeLoad = () => {
     setIsLoading(false)
  }
 

  return (
    <ul className={styles.transactions}>
    { students?.length &&
      students.map((student) => (
        <li key={student.id}>
    {isLoading ?  <div style={{ display: "flex", padding: '15rem', margin: 'auto', justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div> : ""}  
                    
        <iframe onLoad={handleiframeLoad} src={student.form_link} style={{width:'600px', height:'500px'}} frameborder="0"></iframe>
        </li>
      ))
     }
         { students?.form_link &&
    
        <li key={students.id}>
    {isLoading ?  <div style={{ display: "flex", padding: '15rem', margin: 'auto', justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div> : ""}  
                    
        <iframe onLoad={handleiframeLoad} src={students.form_link} style={{width:'600px', height:'500px'}} frameborder="0"></iframe>
        </li>
     
     }
  </ul>
  
  )
}